import { useState, useContext } from "react";
import { SubscribedContext } from "@/providers/Subscribed";
import { Add } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Box,
  Container,
  Drawer,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { currentUser } from "@/App";
import { createThread } from "@/services/api";
import { ArrowUpward, Cancel } from "@mui/icons-material";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

export default function NewThreadContainer() {
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();
  const { artistKey } = useParams();
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const { isSubscribed, handleModalOpen } = useContext(SubscribedContext);

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      return await createThread(currentUser.key, artistKey, title, text);
    },
    onSuccess: async () => {
      console.log("invalidating threads query", artistKey);
      // wait 500ms before invalidating the threads query
      // await new Promise((resolve) => setTimeout(resolve, 1000));
      // queryClient.invalidateQueries({ queryKey: ["threads", artistKey] });
      setText("");
      setTitle("");
      setOpen(false);
      window.location.reload();
    },
  });

  const handleSubmit = () => {
    if (!title) {
      return;
    }
    mutate();
  };

  const handleClick = () => {
    if (isSubscribed) {
      setOpen(true);
    } else {
      handleModalOpen();
    }
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<Add />}
        fullWidth
        size="large"
        style={{ borderRadius: "30px" }}
        sx={{ my: 2 }}
        onClick={handleClick}
      >
        New Topic
      </Button>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        style={{ height: "100%" }}
      >
        <Container maxWidth="md">
          <Box
            elevation={20}
            style={{
              borderRadius: "0",
              padding: "20px",

              height: "50vh",
              overflowY: "scroll",
              // dont show scrollbar
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::WebkitScrollbar": {
                display: "none",
              },
            }}
          >
            <Box
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <IconButton
                variant="text"
                color="info"
                onClick={() => setOpen(false)}
              >
                <Cancel />
              </IconButton>
              <Typography variant="h6">New Topic</Typography>

              <Box style={{ width: "50px" }} />
            </Box>

            <TextField
              fullWidth
              autoComplete="off"
              size="small"
              placeholder="Topic Title..."
              variant="standard"
              value={title}
              sx={{ my: 2 }}
              InputProps={{
                style: {
                  borderRadius: "20px",
                },
              }}
              onChange={(e) => setTitle(e.target.value)}
            />
            <Box
              sx={{
                display: "flex",
                margin: "25px 0",
                alignItems: "flex-start",
              }}
            >
              <Avatar
                src={currentUser.meta.profile}
                sx={{ width: 30, height: 30, mr: 2, mt: 0.5 }}
              />
              <TextField
                fullWidth
                multiline
                autoComplete="off"
                size="small"
                maxRows={4}
                placeholder="Start the conversation with a first comment..."
                variant="outlined"
                value={text}
                style={{ marginRight: "20px" }}
                // make the textfield rounded
                InputProps={{
                  style: {
                    borderRadius: "20px",
                  },
                }}
                onChange={(e) => setText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.ctrlKey && e.key === "Enter") {
                    handleSubmit(e);
                  }
                }}
              />

              <IconButton
                size="small"
                style={{ background: "#9A5AEF" }}
                onClick={handleSubmit}
                sx={{ mt: 0.5 }}
                disabled={isPending || title.length == 0 || text.length == 0}
              >
                <ArrowUpward />
              </IconButton>
            </Box>
          </Box>
        </Container>
      </Drawer>
    </>
  );
}
